import Auth from './Auth'
import { routerGuard } from '../common'
import { frontendcommonCss, logo, logoSmall, logoColor, logoColorSmall, colors } from './frontendcommon'
import URLS from './urls'
import { plugins } from 'frontendcommon-3'
import SidebarBottom from './SidebarBottom'
import LoadingSpinner from './../farmapremium/LoadingSpinner'
import App from './App'
const sidebarLoading = true
const enableMobileLayout = true
const { AxiosPlugin } = plugins

const shellConfigUrl = URLS.SHELL_CONFIG_URL
const sentryDns = 'https://7516d2225f164a3ebb166a4638d098c4@sentry.farmapremium.es/13'

export {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  shellConfigUrl,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner
}
